var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.5C1.5 8.965 1.5 9.1975 1.55111 9.38825C1.68981 9.90585 2.09414 10.3102 2.61177 10.4489C2.80252 10.5 3.03502 10.5 3.5 10.5H8.49998C8.96498 10.5 9.19748 10.5 9.38823 10.4489C9.90588 10.3102 10.3102 9.90585 10.4489 9.38825C10.5 9.1975 10.5 8.965 10.5 8.5",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24999 3.74999C8.24999 3.74999 6.59289 1.50001 5.99999 1.5C5.40704 1.5 3.75 3.75 3.75 3.75M5.99999 2V8.00002",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3424dc32f21289a23b45365e7f25ef5e.svg";
export { ForwardRef as ReactComponent };